.hpLanguageFlag {
  width: 20px;
  border-radius: 4px;
  border: 0.5px solid #7f7f7f;
}

.hpLanguageRadio {
  padding: 0 10px;
  height: 34px;
  line-height: 33px;

  :global(.ant-radio-button-label) {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
